import type { IPackageDesc, PageSchema } from '@tencent/ep-canvas-sdk/src/designer/types';
import { HttpPrefix } from 'src/lib/wemeet-http-moudle';
import http from '@lib/http';
import type { GetServerSidePropsContext } from 'next';

interface Detail {
  code: number;
  msg: string;
  data: {
    /** 草稿 */
    content: string;
    /** 已发布的canvas */
    published_content: string;
    id: string;
    /** 是否主办方 */
    is_host: boolean;
    /** 0: 普通模式, 1: canvas模式 */
    custom_mode: 0 | 1;
  };
}

export type CanvasData = {
  schema?: PageSchema;
  packages?: IPackageDesc[];
  isCanvas?: boolean;
};

// 获取保存的canvas数据
export const getCanvasData = (
  event_id: string,
  /** 是否优先取预览 */
  preview?: boolean,
  source?: number,
  temp_token?: string,
  ctx?: GetServerSidePropsContext,
): Promise<CanvasData> => {
  const path = '/v2/activities/public/dashboard/canvas/detail';
  return http
    .post<Detail>(HttpPrefix.WEMEET_TAPI, path, { event_id, source, temp_token }, ctx)
    .then((res: Detail) => {
      const { code, data, msg } = res;
      if (code === 0) {
        const isCanvas = data.custom_mode === 1;
        const canvasDataStr = preview ? data.content : data.published_content || '{}';
        try {
          return { isCanvas, ...(JSON.parse(canvasDataStr) || {}) };
        } catch {
          return { isCanvas };
        }
      }
      return Promise.reject(msg);
    });
};
